<script setup lang="ts">
/**
 * The navbar's own icons, drawn in Tencent Cloud's manner — thin even
 * strokes in the text colour, round ends, room inside — and picked by the
 * user (2026-10-30): 设置 a window with a gear at its corner, 中英文 中
 * and En with the arrows that swap them, 消息通知 a bell ringing. Redrawn
 * after a look at 2× (what a Retina screen shows): a larger gear of six
 * teeth, 中 and En as type rather than strokes, a bell with shoulders
 * and a flat clapper. 20px, as Tencent's are. The same file in both
 * consoles.
 */
defineProps<{ name: 'settings' | 'language' | 'bell' }>()
</script>

<template>
  <svg class="nav-icon" viewBox="0 0 24 24" aria-hidden="true">
    <template v-if="name === 'settings'">
      <path d="M20.5 9.5v-3a2 2 0 0 0-2-2h-13a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2H9.5M3.5 8.5h17" />
      <path
        d="M15.65 12.92 L15.79 11.46 L17.41 11.46 L17.55 12.92 A3.8 3.8 0 0 1 19.31 13.94 L20.64 13.33 L21.45 14.74 L20.26 15.58 A3.8 3.8 0 0 1 20.26 17.62 L21.45 18.46 L20.64 19.87 L19.31 19.26 A3.8 3.8 0 0 1 17.55 20.28 L17.41 21.74 L15.79 21.74 L15.65 20.28 A3.8 3.8 0 0 1 13.89 19.26 L12.56 19.87 L11.75 18.46 L12.94 17.62 A3.8 3.8 0 0 1 12.94 15.58 L11.75 14.74 L12.56 13.33 L13.89 13.94 A3.8 3.8 0 0 1 15.65 12.92Z"
      />
      <circle cx="16.6" cy="16.6" r="1.5" />
    </template>
    <template v-else-if="name === 'language'">
      <text class="glyph" x="1.6" y="11.4" font-size="10.4">中</text>
      <text class="glyph latin" x="11.2" y="21.4" font-size="9.6">En</text>
      <path d="M13.4 4.4h2.8a3 3 0 0 1 3 3v3M17.6 9l1.6 1.6 1.6-1.6M10.6 19.6H7.8a3 3 0 0 1-3-3v-3M3.2 15l1.6-1.6 1.6 1.6" />
    </template>
    <path
      v-else
      d="M5 18h14c-1-1-1.6-2.2-1.6-4v-3a5.4 5.4 0 0 0-10.8 0v3c0 1.8-.6 3-1.6 4zM10 20.8h4M3.5 8.6c.4-1.4 1.1-2.6 2-3.6M20.5 8.6c-.4-1.4-1.1-2.6-2-3.6"
    />
  </svg>
</template>

<style scoped>
.nav-icon {
  width: 20px;
  height: 20px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.6;
  stroke-linecap: round;
  stroke-linejoin: round;
}
/* 中 and En are type: the system's own CJK and Latin faces, filled. */
.glyph {
  fill: currentColor;
  stroke: none;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  font-weight: 600;
}
.glyph.latin {
  font-family: -apple-system, 'Segoe UI', Helvetica, Arial, sans-serif;
}
</style>
